import { DriverFuelType } from '@pages/driverAnalysis/driverAnalysisReducer';

export const ELECTRIC_RESTRICTED_SUMMARY_SECTION_KEYS = new Set<string>([
    'distanceFuelConsumption',
    'idlingConsumption',
]);

const HIDE_STANDSTILL_AND_DRIVING_CONSUMPTION_SECTION_KEYS = new Set<string>([
    'drivingConsumption',
    'idlingConsumption',
]);

const isRestrictedElectricSummarySection = (sectionKey: string): boolean =>
    ELECTRIC_RESTRICTED_SUMMARY_SECTION_KEYS.has(sectionKey);

const isHiddenByStandstillAndDrivingConsumptionFlag = (sectionKey: string): boolean =>
    HIDE_STANDSTILL_AND_DRIVING_CONSUMPTION_SECTION_KEYS.has(sectionKey);

const isElectricOnlySummaryFuelType = (selectedFuelType: DriverFuelType): boolean => {
    return selectedFuelType === DriverFuelType.ELECTRIC;
};

const isAllSummaryFuelType = (selectedFuelType: DriverFuelType): boolean =>
    selectedFuelType === DriverFuelType.ALL;

export const shouldHideAllSummaryGraphDataForElectricOnly = (
    sectionKey: string,
    selectedFuelType: DriverFuelType,
): boolean =>
    isElectricOnlySummaryFuelType(selectedFuelType) &&
    isRestrictedElectricSummarySection(sectionKey);

export const shouldHideElectricSummaryGraphData = (
    sectionKey: string,
    selectedFuelType: DriverFuelType,
): boolean =>
    isRestrictedElectricSummarySection(sectionKey) &&
    (isElectricOnlySummaryFuelType(selectedFuelType) || isAllSummaryFuelType(selectedFuelType));

export const shouldHideSummarySectionByFeatureFlag = (
    sectionKey: string,
    selectedFuelType: DriverFuelType,
    hideStandSAndDrivingConsumption: boolean,
): boolean =>
    hideStandSAndDrivingConsumption &&
    isElectricOnlySummaryFuelType(selectedFuelType) &&
    isHiddenByStandstillAndDrivingConsumptionFlag(sectionKey);

const HIDE_STANDSTILL_AND_DRIVING_CONSUMPTION_TABLE_COLUMN_KEYS = new Set<string>([
    'drivingConsumption',
    'idlingConsumption',
    'electricAverageDrivingConsumption',
    'electricAverageIdlingConsumption',
]);

const isHiddenTableColumnByStandstillAndDrivingConsumptionFlag = (columnKey: string): boolean =>
    HIDE_STANDSTILL_AND_DRIVING_CONSUMPTION_TABLE_COLUMN_KEYS.has(columnKey);

export const shouldHideTableColumnByFeatureFlag = (
    columnKey: string,
    selectedFuelType: DriverFuelType,
    hideStandSAndDrivingConsumption: boolean,
): boolean =>
    hideStandSAndDrivingConsumption &&
    isElectricOnlySummaryFuelType(selectedFuelType) &&
    isHiddenTableColumnByStandstillAndDrivingConsumptionFlag(columnKey);
